import { createSlice } from "@reduxjs/toolkit";

interface surfaceEquipmentState {
    surfaceEquipData: any;
};

export const initialState: surfaceEquipmentState = {
    surfaceEquipData: [],
};

const SurfaceEquipSlice = createSlice({
    name: "surface-equipment",
    initialState,
    reducers: {
        setSurfaceEquipmentData: (state, action) => {
            state.surfaceEquipData = action?.payload;
        },
    },
});

export const {
    setSurfaceEquipmentData
} = SurfaceEquipSlice.actions;

export default SurfaceEquipSlice.reducer;